// UploadStep.tsx

import React, { useContext, useEffect, useState } from 'react'
import {
  Container,
  ProgressFill,
  FileInputDiv,
  FileInputLabel,
  FileInput,
  FileInfoDiv,
  FileInfoImg,
  FileMiddleDiv,
  FileUpperMiddleDiv,
  FileName,
  FileInfoCancelImg,
  FileFirstText,
  FileSecondText,
} from './style'
import fileIcon from '../../../../../../assets/certificates/AddParameter/file.svg'
import cancelIcon from '../../../../../../assets/certificates/AddParameter/cancel.svg'
import CertificatesContext from '../../../../../../contexts/CertificatesContext'

interface FileInputProps {
  index: number
}

const FileInputStructure: React.FC<FileInputProps> = (props) => {
  const { structureData, setStructureData } = useContext(CertificatesContext)

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return
  
    setStructureData((prevData) => {
      return prevData.map((structure, index) => {
        if (index === props.index) {
          return { ...structure, structureFile: file }
        }
        return structure
      })
    })
  }

  console.log(structureData[1].structureFile)
  
  const handleDelete = () => {
    const newData = [...structureData]
    newData[props.index].structureFile = null
    setStructureData(newData)
  }

  return (
    <Container>
      {structureData[props.index].structureFile === null ? 
        <FileInputDiv>
            <FileInputLabel htmlFor='invoice'>
                Procurar
                <FileInput 
                  type='file'
                  id='invoice'
                  name='invoice'
                  onChange={(e) => handleUpload(e)}
                />
            </FileInputLabel>
            <FileFirstText>ou arraste um arquivo até aqui</FileFirstText>
            <FileSecondText>Apenas arquivos .pdf de no máximo 10mb</FileSecondText>
        </FileInputDiv> 
        :
        <>
        <FileInfoDiv>
            <FileInfoImg src={fileIcon} alt='File icon'/>
            <FileMiddleDiv>
                <FileUpperMiddleDiv>
                    <FileName>{structureData[props.index].structureFile?.name}</FileName>
                </FileUpperMiddleDiv>
            </FileMiddleDiv>
            <FileInfoCancelImg 
                src={cancelIcon} 
                alt='File icon'
                onClick={() => handleDelete()}
            />
        </FileInfoDiv>
        </>
      }
    </Container>
  )
}

export default FileInputStructure
